export const deck = {
  pt: {
    ui: { prev: "Anterior", next: "Próximo", print: "Imprimir / PDF", of: "de", back: "gtstrategy.com.br", fs: "Tela cheia (F)", edit: "Editar textos" },
    s1: {
      title: "Projetos de mudança que melhoram a forma como empresas trabalham.",
      sub: "Estratégia, processos, gestão e tecnologia conectados para gerar eficiência, controle e resultados mensuráveis.",
      slogan: "Evoluímos negócios. Transformamos culturas.",
    },
    s2: {
      title: "O crescimento aumenta a complexidade.",
      title2: "Nem sempre a forma de trabalhar acompanha.",
      sub: "Empresas crescem, criam áreas, sistemas, indicadores e rotinas — mas muitas vezes o fluxo de valor fica fragmentado.",
      items: [
        "Áreas que não se conectam",
        "Processos dependentes de pessoas-chave",
        "Sistemas e dados fragmentados",
        "Indicadores que não orientam decisão",
        "Projetos importantes que não saem do papel",
        "Tecnologia sem aderência ao dia a dia",
      ],
      closing: "Muitas empresas têm boas pessoas, boas ideias e boas ferramentas — mas ainda assim perdem eficiência porque o valor não flui como deveria.",
    },
    s3: {
      text: "A GT Strategy conduz projetos de mudança junto com empresas para melhorar a forma como elas trabalham, conectando estratégia, processos, gestão e tecnologia para gerar eficiência, controle e resultados mensuráveis.",
      label: "O que fazemos",
    },
    s4: {
      title: "Antes de propor mudanças, entendemos como o negócio funciona.",
      sub: "Não começamos procurando problemas. Começamos entendendo como o negócio gera valor, como esse valor flui e onde ele perde força.",
      questions: [
        "Como o negócio funciona?",
        "O que já existe de melhor aqui dentro?",
        "Como o valor é gerado?",
        "Como o valor flui entre áreas, pessoas, processos e sistemas?",
        "Onde esse fluxo encontra gargalos?",
        "O que está desbalanceado: estratégia, tática, operação, processos, pessoas ou ferramentas?",
        "Como balancear a empresa para atingir seus objetivos?",
      ],
      center: "FLUXO DE VALOR",
      dims: ["Estratégia", "Tática", "Operação", "Processos", "Pessoas", "Ferramentas"],
      closing: "Nosso trabalho é balancear o negócio para que estratégia, operação, pessoas, processos e tecnologia trabalhem na mesma direção.",
    },
    s5: {
      title: "Capacidades que se aplicam em diferentes níveis do negócio.",
      sub: "A GT Strategy atua onde a mudança precisa acontecer: na estratégia, na tática, na operação — ou conectando os três.",
      cols: ["Estratégico", "Tático", "Operacional"],
      rows: [
        { t: "Entender", c: ["Direção, objetivos e maturidade", "Fluxos, governança e indicadores", "Atividades, gargalos e rotinas"] },
        { t: "Organizar", c: ["Modelo de gestão", "Processos, papéis e rituais", "Execução, controles e documentos"] },
        { t: "Digitalizar", c: ["Arquitetura e dados", "Sistemas, integrações e automações", "Ferramentas, IA aplicada e dashboards"] },
        { t: "Sustentar", c: ["Cultura de gestão", "Treinamento e acompanhamento", "Adoção, rotina e melhoria contínua"] },
      ],
      closing: "O contexto define o ponto de entrada. O método garante a conexão entre negócio, gestão e execução.",
    },
    s6: {
      title: "STRATFLOW: nossa forma de conduzir projetos de mudança.",
      sub: "Metodologia proprietária para conduzir projetos com liberdade de solução, foco em valor agregado e aderência à realidade operacional do cliente.",
      steps: [
        { t: "Entender o negócio" },
        { t: "Mapear o fluxo de valor", note: "Atividades, sistemas e dados" },
        { t: "Identificar desbalanceamentos" },
        { t: "Desenhar soluções" },
        { t: "Implementar mudanças" },
        { t: "Sustentar resultados" },
      ],
      closing: "O STRATFLOW evita que a solução venha antes do entendimento do negócio.",
    },
    s7: {
      title: "HandOff Mapping: entendemos como o valor realmente flui.",
      sub: "O HandOff Mapping conecta a leitura do negócio com a realidade operacional, mostrando como áreas, atividades, sistemas, documentos e dados se relacionam.",
      map_label: "Mapeamos a interrelação entre:",
      map: ["Áreas", "Atividades", "Etapas", "Ferramentas", "Sistemas de gestão", "Documentos", "Dados", "Atributos", "Responsabilidades"],
      reveal_label: "Isso nos permite revelar:",
      reveals: ["Gargalos", "Retrabalho", "Baixa integração", "Falhas de informação", "Dependência de pessoas-chave", "Oportunidades de digitalização", "Desalinhamento entre estratégia, tática e operação"],
      closing: "O objetivo não é mapear por mapear. É entender onde precisamos focar para gerar eficiência, controle e resultado.",
    },
    s8: {
      title: "De esforços dispersos para gestão conectada.",
      sub: "Quando gestão, rotina e decisão não estão conectadas, a empresa perde velocidade, controle e previsibilidade.",
      before: "Antes",
      after: "Depois",
      items: [
        "Redesenho de PMO de construtora",
        "Programas de excelência operacional",
        "Governança de portfólio",
        "Rituais executivos",
        "Indicadores de decisão",
        "Monitoramento e controle",
        "Programas com mais de meio bilhão de dólares em valor capturado",
      ],
      closing: "Gestão não é só acompanhar indicadores. É criar um sistema de decisão e execução.",
    },
    s9: {
      title: "Tecnologia como solução de negócio.",
      sub: "A tecnologia entra quando melhora o fluxo de valor, reduz atrito ou aumenta a capacidade de decisão.",
      items: [
        "Plataforma personalizada de gestão de pessoas e hub de conhecimento",
        "Plataforma de procurement e estimate",
        "Automação de processos com Office, Power Platform e IA",
        "Integração de bases, dashboards e sistemas de gestão",
        "Soluções digitais sob demanda",
      ],
      closing: "Não digitalizamos processos ruins. Entendemos o negócio, redesenhamos o fluxo e aplicamos tecnologia onde ela gera valor real.",
    },
    s10: {
      title: "IA onde existe ganho real de eficiência, qualidade ou decisão.",
      sub: "A IA não é o ponto de partida. Ela é uma alavanca quando existe um problema real de processo, escala, qualidade ou decisão.",
      gains: { e: "Eficiência", q: "Qualidade", d: "Decisão", s: "Escala" },
      items: [
        { t: "Modelo de IA para qualidade de inspeção de ativos rodoviários", g: "q" },
        { t: "Plataforma AI-based para análise de cronogramas de construção", g: "d" },
        { t: "Agente de comparação, qualidade e cenários de cronograma", g: "d" },
        { t: "Knowledge base / RAG corporativo", g: "s" },
        { t: "Agente de fluxos de negócios para treinamento", g: "s" },
        { t: "Agente de análise documental e geração de dashboards", g: "e" },
        { t: "Agente de documentação e treinamento de ferramentas internas", g: "e" },
        { t: "Agente de leveling para construção civil", g: "e" },
        { t: "Agente de levantamento de escopo e quantidades a partir de documentos técnicos", g: "e" },
      ],
      closing: "A pergunta não é \u201Conde podemos usar IA?\u201D. A pergunta é \u201Conde existe valor travado que a IA pode destravar?\u201D.",
    },
    s11: {
      title: "Da operação ao planejamento estratégico.",
      sub: "A experiência da GT Strategy combina execução operacional, processos, tecnologia, comportamento humano e liderança de programas de grande porte.",
      items: [
        "Operações simples e críticas do dia a dia",
        "Ambientes operacionais com milhares de pessoas",
        "Programas de excelência operacional",
        "Planejamento estratégico de negócios de grande porte",
        "Digitalização de operações complexas",
        "Projetos em construção, indústria, infraestrutura, serviços e real estate",
      ],
      closing: "Essa diversidade nos permite conectar estratégia e execução com pragmatismo.",
    },
    s12: {
      title: "Pontos de partida para uma conversa prática.",
      sub: "Cada empresa tem um contexto. Por isso, os bons projetos começam pela identificação do ponto certo de entrada.",
      items: [
        "Diagnóstico de maturidade operacional e digital",
        "HandOff Mapping de processos críticos",
        "Sprint de oportunidades de IA aplicada",
        "Redesenho de PMO / governança",
        "Automação de processos com alto retrabalho",
        "Revisão de indicadores, dados e rotinas de gestão",
        "Desenvolvimento de solução sob demanda",
      ],
      closing: "O ponto de partida depende do contexto. A lógica é sempre a mesma: entender o negócio, identificar onde o valor perde força e construir uma solução aderente.",
    },
    s13: {
      title: "Atuamos onde a complexidade exige conexão entre estratégia, operação e tecnologia.",
      markets_label: "Mercados",
      markets: ["Construção e engenharia", "Infraestrutura", "Indústria", "Real estate", "Serviços B2B", "Operações intensivas em campo", "Empresas em crescimento ou reorganização"],
      contexts_label: "Contextos",
      contexts: ["Crescimento acelerado", "Baixa integração entre áreas", "Mudança de sistema ou digitalização", "Reestruturação de gestão", "Projetos estratégicos com baixa execução", "Operações com muito retrabalho ou dependência de pessoas-chave"],
    },
    s14: {
      title: "Projetos de mudança que ficam no dia a dia.",
      sub: "A GT Strategy conecta experiência prática, método e tecnologia para construir soluções aderentes à realidade de cada cliente.",
      slogan: "Evoluímos negócios. Transformamos culturas.",
    },
  },
  en: {
    ui: { prev: "Previous", next: "Next", print: "Print / PDF", of: "of", back: "gtstrategy.com.br", fs: "Fullscreen (F)", edit: "Edit texts" },
    s1: {
      title: "Change projects that improve the way companies work.",
      sub: "Strategy, processes, management and technology connected to deliver efficiency, control and measurable results.",
      slogan: "We evolve businesses. We transform cultures.",
    },
    s2: {
      title: "Growth increases complexity.",
      title2: "The way of working doesn't always keep up.",
      sub: "Companies grow, create areas, systems, indicators and routines — but the value flow often becomes fragmented.",
      items: [
        "Areas that don't connect",
        "Processes dependent on key people",
        "Fragmented systems and data",
        "Indicators that don't guide decisions",
        "Important projects that never leave the drawing board",
        "Technology with no adherence to day-to-day work",
      ],
      closing: "Many companies have good people, good ideas and good tools — yet still lose efficiency because value doesn't flow the way it should.",
    },
    s3: {
      text: "GT Strategy leads change projects together with companies to improve the way they work, connecting strategy, processes, management and technology to deliver efficiency, control and measurable results.",
      label: "What we do",
    },
    s4: {
      title: "Before proposing changes, we understand how the business works.",
      sub: "We don't start by looking for problems. We start by understanding how the business creates value, how that value flows and where it loses strength.",
      questions: [
        "How does the business work?",
        "What is already best-in-class in here?",
        "How is value created?",
        "How does value flow across areas, people, processes and systems?",
        "Where does this flow hit bottlenecks?",
        "What is out of balance: strategy, tactics, operations, processes, people or tools?",
        "How do we balance the company to reach its goals?",
      ],
      center: "VALUE FLOW",
      dims: ["Strategy", "Tactics", "Operations", "Processes", "People", "Tools"],
      closing: "Our job is to balance the business so that strategy, operations, people, processes and technology move in the same direction.",
    },
    s5: {
      title: "Capabilities that apply at different levels of the business.",
      sub: "GT Strategy works where change needs to happen: in strategy, in tactics, in operations — or connecting all three.",
      cols: ["Strategic", "Tactical", "Operational"],
      rows: [
        { t: "Understand", c: ["Direction, goals and maturity", "Flows, governance and indicators", "Activities, bottlenecks and routines"] },
        { t: "Organize", c: ["Management model", "Processes, roles and rituals", "Execution, controls and documents"] },
        { t: "Digitalize", c: ["Architecture and data", "Systems, integrations and automations", "Tools, applied AI and dashboards"] },
        { t: "Sustain", c: ["Management culture", "Training and follow-up", "Adoption, routine and continuous improvement"] },
      ],
      closing: "Context defines the entry point. The method guarantees the connection between business, management and execution.",
    },
    s6: {
      title: "STRATFLOW: our way of leading change projects.",
      sub: "A proprietary methodology to lead projects with solution freedom, focus on added value and adherence to the client's operational reality.",
      steps: [
        { t: "Understand the business" },
        { t: "Map the value flow", note: "Activities, systems and data" },
        { t: "Identify imbalances" },
        { t: "Design solutions" },
        { t: "Implement changes" },
        { t: "Sustain results" },
      ],
      closing: "STRATFLOW prevents the solution from coming before the understanding of the business.",
    },
    s7: {
      title: "HandOff Mapping: we understand how value really flows.",
      sub: "HandOff Mapping connects the reading of the business with operational reality, showing how areas, activities, systems, documents and data relate to each other.",
      map_label: "We map the interrelation between:",
      map: ["Areas", "Activities", "Stages", "Tools", "Management systems", "Documents", "Data", "Attributes", "Responsibilities"],
      reveal_label: "This allows us to reveal:",
      reveals: ["Bottlenecks", "Rework", "Low integration", "Information gaps", "Dependence on key people", "Digitalization opportunities", "Misalignment between strategy, tactics and operations"],
      closing: "The goal is not mapping for its own sake. It's understanding where to focus to deliver efficiency, control and results.",
    },
    s8: {
      title: "From scattered efforts to connected management.",
      sub: "When management, routines and decisions aren't connected, the company loses speed, control and predictability.",
      before: "Before",
      after: "After",
      items: [
        "Construction company PMO redesign",
        "Operational excellence programs",
        "Portfolio governance",
        "Executive rituals",
        "Decision indicators",
        "Monitoring and control",
        "Programs with more than half a billion dollars in captured value",
      ],
      closing: "Management isn't just tracking indicators. It's building a decision and execution system.",
    },
    s9: {
      title: "Technology as a business solution.",
      sub: "Technology comes in when it improves the value flow, reduces friction or increases decision capability.",
      items: [
        "Custom people-management platform and knowledge hub",
        "Procurement and estimating platform",
        "Process automation with Office, Power Platform and AI",
        "Integration of databases, dashboards and management systems",
        "On-demand digital solutions",
      ],
      closing: "We don't digitalize bad processes. We understand the business, redesign the flow and apply technology where it creates real value.",
    },
    s10: {
      title: "AI where there is real gain in efficiency, quality or decision-making.",
      sub: "AI isn't the starting point. It's a lever when there is a real problem of process, scale, quality or decision-making.",
      gains: { e: "Efficiency", q: "Quality", d: "Decision", s: "Scale" },
      items: [
        { t: "AI model for road-asset inspection quality", g: "q" },
        { t: "AI-based platform for construction schedule analysis", g: "d" },
        { t: "Schedule comparison, quality and scenario agent", g: "d" },
        { t: "Corporate knowledge base / RAG", g: "s" },
        { t: "Business-flow agent for training", g: "s" },
        { t: "Document analysis and dashboard generation agent", g: "e" },
        { t: "Documentation and training agent for internal tools", g: "e" },
        { t: "Leveling agent for construction", g: "e" },
        { t: "Scope and quantity take-off agent from technical documents", g: "e" },
      ],
      closing: "The question isn't \u201Cwhere can we use AI?\u201D. The question is \u201Cwhere is value locked that AI can unlock?\u201D.",
    },
    s11: {
      title: "From operations to strategic planning.",
      sub: "GT Strategy's experience combines operational execution, processes, technology, human behavior and leadership of large-scale programs.",
      items: [
        "Simple and critical day-to-day operations",
        "Operational environments with thousands of people",
        "Operational excellence programs",
        "Strategic planning for large businesses",
        "Digitalization of complex operations",
        "Projects in construction, industry, infrastructure, services and real estate",
      ],
      closing: "This diversity allows us to connect strategy and execution with pragmatism.",
    },
    s12: {
      title: "Starting points for a practical conversation.",
      sub: "Every company has a context. That's why good projects start by identifying the right entry point.",
      items: [
        "Operational and digital maturity diagnostic",
        "HandOff Mapping of critical processes",
        "Applied-AI opportunity sprint",
        "PMO / governance redesign",
        "Automation of high-rework processes",
        "Review of indicators, data and management routines",
        "On-demand solution development",
      ],
      closing: "The starting point depends on context. The logic is always the same: understand the business, identify where value loses strength and build an adherent solution.",
    },
    s13: {
      title: "We work where complexity demands connection between strategy, operations and technology.",
      markets_label: "Markets",
      markets: ["Construction and engineering", "Infrastructure", "Industry", "Real estate", "B2B services", "Field-intensive operations", "Companies growing or reorganizing"],
      contexts_label: "Contexts",
      contexts: ["Accelerated growth", "Low integration between areas", "System change or digitalization", "Management restructuring", "Strategic projects with low execution", "Operations with heavy rework or dependence on key people"],
    },
    s14: {
      title: "Change projects that stay in the day-to-day.",
      sub: "GT Strategy connects practical experience, method and technology to build solutions adherent to each client's reality.",
      slogan: "We evolve businesses. We transform cultures.",
    },
  },
};
